import { render, staticRenderFns } from "./frameSettingCalendarRoomType.vue?vue&type=template&id=7bd91f58&scoped=true&"
import script from "./frameSettingCalendarRoomType.vue?vue&type=script&lang=js&"
export * from "./frameSettingCalendarRoomType.vue?vue&type=script&lang=js&"
import style0 from "./frameSettingCalendarRoomType.vue?vue&type=style&index=0&id=7bd91f58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd91f58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
